var cell_default = {
  "cell": "JB2-Y",
  "header": "_3X0Ji",
  "selected": "zZOKg",
  "editing": "QaSuL",
  "singleSelection": "LwHqR",
  "hideLastBlock": "fAYke",
  "editorWrapper": "SnbGn",
  "viewerWrapper": "wDoDI",
  "hideFirstBlock": "KazlW",
  "editor": "iPqz2",
  "edit": "-jSQK",
  "view": "fiqm9",
  "editingToolbarWrapper": "eSgnh",
  "selectAll": "OBjfa",
  "disableSelection": "clmcq"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
